import React from 'react';
import Layout from '../../scaffolding/Layout';

const Workshops = () => {
  return <Layout>Workshops</Layout>;
};

export default Workshops;
